import {useEffect, useState } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import DataTable from "../../component/DataTable";
import AdminHeader from "../../component/AdminHeader";

const homeformListEndpoint = ApiEndpoints.homeform.homeformList;

const tableHeader = ["Date", "Name", "email", "company", "website", "phone", "job title", "avg. monthly order", "comp. location",  "manuf. location", "message", "Source Url", "current Url"];
const tbody = ["createdAt", "name", "email", "company", "company_website", "phoneNumber", "job_title", "avg_monthly_order", "company_location", "manufacture_location", "message", "source_url",  "current_url"];

export default function HomeContact() {
    const [data, setData] = useState([]);

    const dataFetch = async () => {
        try {
            const response = await ApiRequest("GET", homeformListEndpoint);
            const result = response.homeform;
            setData(result);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        dataFetch();
    }, []);


    const pagename = {
      name: 'Home Contact',
      user: 'Admin',
      innerpage: 'Home Contact'
    }

  return (
    <>
    <AdminHeader pagename={pagename}/>

    <div className="add-btn-section contact-manage-tab">
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          showAction={false}
        />
    </div>
    </>
  )
}
